import React from 'react'

import { Box, Card } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(
  ({ customShadows, spacing }) => ({
    root: {
      transition: 'box-shadow 0.2s',
      width: '100%',
      height: '100%'
    },
    card: {
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(1.25),
      justifyContent: 'space-between',
      width: '100%',
      height: '100%',
      padding: spacing(2),
      '&:hover': {
        boxShadow: customShadows.cardHover
      }
    },
    cardContent: {
      display: 'flex',
      flexDirection: 'row',
      gap: spacing(2.5)
    }
  })
)

const SkillBuilderCardContainer = ({ children, dataTest, onClick, ...props }) => {
  const classes = useStyles(props)
  return (
    <Box
      className={classes.root}
      data-test={dataTest}
    >
      <Card variant='elevation' classes={{ root: classes.card }} onClick={onClick}>
        {children}
      </Card>
    </Box>
  )
}

export default SkillBuilderCardContainer
